import { createReducer, on } from "@ngrx/store";
import { InitialRegionalState } from "./regional-setting.state";
import { RegionalActions } from "./regional-setting.actions";

export const RegionalReducer = createReducer(InitialRegionalState,
  on(RegionalActions.loadData, (state, { country, currency, language }) => ({ ...state, country, currency, language })),
  on(RegionalActions.changeCountry, (state, { country }) => ({ ...state, country })),
  on(RegionalActions.changeCurrency, (state, { currency }) => ({ ...state, currency })),
  on(RegionalActions.changeLanguage, (state, { language }) => ({ ...state, language })),
  on(RegionalActions.updateData, (state, { country, currency, language }) => ({ ...state, country, currency, language })),
)